import { SearchableFieldId } from '~/redux/api/methods/alert';
import { pilot } from '~/services/serviceInstances';

import { SuggestionsResponse } from './mergeSuggestionSources';

export const getPilotPresetOptions = (
  fieldId: SearchableFieldId,
  substringQuery: string,
): Promise<SuggestionsResponse> => {
  const url = `document-information-fields/${fieldId}/preset-options`;

  return pilot.get(url, {
    params: {
      substring_query: substringQuery || undefined,
    },
  });
};

export const getPilotDocumentGroupSuggestions = (
  fieldId: SearchableFieldId,
  substringQuery: string,
): Promise<SuggestionsResponse> => {
  const url = `search/searchable/field-suggestions/${fieldId}/`;

  return pilot.get(url, {
    params: {
      query: substringQuery || undefined,
    },
  });
};
